/**
 * Set any external links to open in new tab
 * @param {Node} el
 */
export default function adjustExternalLinks(el) {
  const links = Array.prototype.slice.call(el.getElementsByTagName("a"));

  links.forEach(link => {
    if (link.hostname !== window.location.hostname) {
      link.target = "_blank";
      link.rel = "noopener";
    }
  });
}
